<ion-item lines="none" class="chat-message">
  <sc-avatar
    [name]="participants.get(chatMessage.uid)?.name"
    [photoURL]="participants.get(chatMessage.uid)?.info?.avatarUrl"></sc-avatar>

  <ion-label class="ion-text-wrap">
    <span class="body-bold">
      {{ chatMessage.name }}
    </span>

    <ion-badge class="sc-color-black-75 sc-color-secondary-light-mode-bg pica-bold-caps">
      {{ rolesService.display(chatMessage.role) }}
    </ion-badge>

    <span class="micro-regular">
      {{ chatMessage.datetime | date: 'h:mm a' }}
      <span *ngIf="!isToday">{{ chatMessage.datetime | date: 'MMM d, y' }}</span>
      <span *ngIf="isToday">Today</span>
    </span>

    <p
      [innerHTML]="chatMessage.message | atMention | linkify | gif: scrollToBottom | trust: 'html'"
      class="body-regular"></p>

    <ion-row *ngIf="reactions" class="reactions ion-no-padding">
      <ion-chip
        *ngFor="let reaction of reactions; trackBy: trackByReaction"
        (click)="toggleReaction(reaction.emoji, chatMessage)"
        [tooltip]="reaction.users.join(', ')">
        <span class="emoji">
          {{ reaction.emoji }}
        </span>

        <span class="count micro-bold">
          {{ reaction.users.length }}
        </span>
      </ion-chip>
    </ion-row>

    <div class="reactionsPanel">
      <ion-row>
        <ion-col *ngFor="let reaction of reactionOptions" (click)="toggleReaction(reaction, chatMessage)">
          {{ reaction }}
        </ion-col>
      </ion-row>
    </div>
  </ion-label>
</ion-item>
